<template>
  <div class="search-detail-company">
    <div class="search-result search-history" v-if="!currentStr && history.length">
      <!-- 搜索历史 -->
        <div class="history-item" v-for="(item, i) in history" :key="i" @click="setHistory(item)">
          {{ item }}
        </div>
    </div>
    <div class="search-loading" v-else-if="isSearch">
      <div>搜索中</div>
    </div>
    <div class="search-result" v-else-if="searchList.length">
      <div class="history-item" v-for="(item, i) in searchList" :key="i" @click="toMatchDetail(item)">
        {{ item.name }}
      </div>
    </div>
    <div class="search-empty" v-else>
      <no-data content="无法找到该企业" />
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import { getSearchHistory } from '@/utils/storage'
export default {
  components: { NoData },
  name: "searchDetail",
  props:{
      searchList: '',
      isSearch: false,
      currentStr: '',
  },
  data(){
    return{
      history: [],
    }
  },
  mounted(){
    this.loadSearchHistory()
  },
  methods:{
      async loadSearchHistory() {
        let resp = getSearchHistory()
        this.history = resp.filter((item) => item) || []
      },
    setHistory(item){
      this.$emit('updateSearchStr', item)
    },
    async toMatchDetail(item) {
      this.$emit('toMatchDetail',item)
    },
  }

}
</script>
<style lang="scss">
.search-detail-company {
  width: 100%;
  background: #fff;
  z-index: 999;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  min-height: 50px;
}

.search-result .history-item {
  padding: 10px 0px;
  color: #1b53b9;
  border-bottom: 1px solid #eee;
  font-size: 12px;
}

.search-history .history-item {
  padding: 5px 0px;
  color: #808080;
  font-size: 12px;
}
.search-result .history-item:last-child {
  border-bottom: none;
}
.search-empty {
  height: 120px;
}
.search-hot {
  background: #fff;
}
.match-item {
  margin-bottom: 10px;
  position: relative;
  padding: 6px 20px 6px 30px;
}
.match-item:nth-child(odd) {
  background: #f9f9f9;
}
.match-item:before {
  content: '';
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #aaa;
  position: absolute;
  left: 18px;
  top: 13px;
}
.match-item > view {
  display: inline;
  color: #aaa;
  font-size: 12px;
  line-height: 1.5;
}
.match-item > .bold {
  color: #252525;
  margin: 0 5px;
}
.add-company-btn {
  margin-top: 8px;
}
.search-loading {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ddd;
}
.flex-button{
  
}
</style>
